// Переводы для интерфейса
export interface Translations {
  // Common strings
  appname: string;

  // User informing strings
  error_server: string;
  info_loading_wait: string;
  coming_soon: string;
  check_internet_headline: string;
  check_internet: string;
  need_to_sign_in: string;

  // Pages strings
  home: string;
  serials: string;
  movies: string;
  collections: string;
  charts: string;

  // Home page strings
  studios: string;

  // Movie page strings
  you_may_also_like: string;
  information: string;
  year: string;
  imdb_rating: string;
  country: string;
  director: string;
  no_info: string;

  // Serial page strings
  season: string;
  episodes: string;
  choose_season: string;
  seasons: string;
  search: string;

  // Fiction page strings
  audio_tracks: string;
  subtitles: string;
  description: string;
  watch_now: string;

  // Account page strings
  screenify_user: string;
  account: string;
  sign_in: string;
  email: string;
  email_headline: string;
  password: string;
  password_headline: string;

  // Search page strings
  all_in_one: string;
  total_films_and_series: string;
  click_to_search: string;
  search_for: string;
  no_results: string;
  more: string;
  search_results_for: string;
  search_total: string;

  // Menu strings
  tv: string;
}

// Французский язык
export const FR_TRANSLATIONS: Translations = {
  // Common strings
  appname: "SCREENIFY",

  // User informing strings
  error_server: "Erreur du serveur. Veuillez réessayer plus tard...",
  info_loading_wait: "Chargement. Veuillez patienter...",
  coming_soon: "Bientôt disponible...",
  check_internet_headline: "Réseau lent détecté.",
  check_internet: "Vérifiez votre connexion s'il vous plaît.",
  need_to_sign_in: "CONNECTEZ-VOUS POUR CONTINUER À REGARDER",

  // Pages strings
  home: "ACCUEIL",
  serials: "SÉRIES",
  movies: "FILMS",
  collections: "COLLECTIONS",
  charts: "CLASSEMENTS",

  // Home page strings
  studios: "STUDIOS",

  // Movie page strings
  you_may_also_like: "VOUS POURRIEZ AUSSI AIMER",
  information: "INFORMATIONS",
  year: "ANNÉE",
  imdb_rating: "NOTE IMDB",
  country: "PAYS",
  director: "RÉALISATEUR",
  no_info: "Aucune information",

  // Serial page strings
  season: "SAISON",
  episodes: "ÉPISODES",
  choose_season: "CHOISIR LA SAISON",
  seasons: "SAISONS",
  search: "RECHERCHER",

  // Fiction page strings
  audio_tracks: "PISTES AUDIO",
  subtitles: "SOUS-TITRES",
  description: "DESCRIPTION",
  watch_now: "REGARDER MAINTENANT",

  // Account page strings
  screenify_user: "UTILISATEUR SCREENIFY",
  account: "COMPTE",
  sign_in: "SE CONNECTER",
  email: "E-MAIL",
  email_headline: "Entrez votre e-mail",
  password: "MOT DE PASSE",
  password_headline: "Entrez votre mot de passe",

  // Search page strings
  all_in_one: "TOUT EN UN",
  total_films_and_series: "Vous ne trouvez pas un film ou une série ? Entrez le titre d'un film ou d'une série en anglais. Nous avons tout ce dont vous avez besoin !",
  click_to_search: "CLIQUEZ POUR RECHERCHER...",
  search_for: "RECHERCHER DU CONTENU, DES FILMS ET DES ACTEURS",
  no_results: "AUCUN RÉSULTAT DISPONIBLE",
  more: "CHARGER PLUS",
  search_results_for: "RÉSULTATS POUR",
  search_total: "TOTAL",

  // Menu strings
  tv: "TV",
};

// Португальский язык
export const PT_TRANSLATIONS: Translations = {
  // Common strings
  appname: "SCREENIFY",

  // User informing strings
  error_server: "Erro do servidor. Tente novamente mais tarde...",
  info_loading_wait: "Carregando. Aguarde por favor...",
  coming_soon: "Em breve...",
  check_internet_headline: "Rede lenta detectada.",
  check_internet: "Verifique sua conexão por favor.",
  need_to_sign_in: "ENTRE PARA CONTINUAR ASSISTINDO",

  // Pages strings
  home: "INÍCIO",
  serials: "SÉRIES",
  movies: "FILMES",
  collections: "COLEÇÕES",
  charts: "RANKINGS",

  // Home page strings
  studios: "ESTÚDIOS",

  // Movie page strings
  you_may_also_like: "VOCÊ TAMBÉM PODE GOSTAR",
  information: "INFORMAÇÕES",
  year: "ANO",
  imdb_rating: "NOTA IMDB",
  country: "PAÍS",
  director: "DIRETOR",
  no_info: "Sem informações",

  // Serial page strings
  season: "TEMPORADA",
  episodes: "EPISÓDIOS",
  choose_season: "ESCOLHER TEMPORADA",
  seasons: "TEMPORADAS",
  search: "BUSCAR",

  // Fiction page strings
  audio_tracks: "FAIXAS DE ÁUDIO",
  subtitles: "LEGENDA",
  description: "DESCRIÇÃO",
  watch_now: "ASSISTIR AGORA",

  // Account page strings
  screenify_user: "USUÁRIO SCREENIFY",
  account: "CONTA",
  sign_in: "ENTRAR",
  email: "E-MAIL",
  email_headline: "Digite seu e-mail",
  password: "SENHA",
  password_headline: "Digite sua senha",

  // Search page strings
  all_in_one: "TUDO EM UM",
  total_films_and_series: "Não encontra um filme ou série? Insira o título de um filme ou série em inglês. Temos tudo o que você precisa!",
  click_to_search: "CLIQUE PARA BUSCAR...",
  search_for: "BUSCAR CONTEÚDO, FILMES E ATORES",
  no_results: "NENHUM RESULTADO DISPONÍVEL",
  more: "CARREGAR MAIS",
  search_results_for: "RESULTADOS PARA",
  search_total: "TOTAL",

  // Menu strings
  tv: "TV",
};

// Английский язык (по умолчанию)
export const EN_TRANSLATIONS: Translations = {
  // Common strings
  appname: "SCREENIFY",

  // User informing strings
  error_server: "Server error. Please try later...",
  info_loading_wait: "Loading. Wait please...",
  coming_soon: "Coming soon...",
  check_internet_headline: "Slow network is detected.",
  check_internet: "Check your connection please.",
  need_to_sign_in: "SIGN IN TO CONTINUE WATCHING",

  // Pages strings
  home: "HOME",
  serials: "SERIALS",
  movies: "MOVIES",
  collections: "COLLECTIONS",
  charts: "CHARTS",

  // Home page strings
  studios: "STUDIOS",

  // Movie page strings
  you_may_also_like: "YOU MAY ALSO LIKE",
  information: "INFORMATION",
  year: "YEAR",
  imdb_rating: "IMDB RATING",
  country: "COUNTRY",
  director: "DIRECTOR",
  no_info: "No info",

  // Serial page strings
  season: "SEASON",
  episodes: "EPISODES",
  choose_season: "CHOOSE SEASON",
  seasons: "SEASONS",
  search: "SEARCH",

  // Fiction page strings
  audio_tracks: "AUDIO TRACKS",
  subtitles: "SUBTITLES",
  description: "DESCRIPTION",
  watch_now: "WATCH NOW",

  // Account page strings
  screenify_user: "SCREENIFY USER",
  account: "ACCOUNT",
  sign_in: "SIGN IN",
  email: "EMAIL",
  email_headline: "Enter your email",
  password: "PASSWORD",
  password_headline: "Enter your password",

  // Search page strings
  all_in_one: "ALL IN ONE",
  total_films_and_series: "100.000+ FILMS AND SERIES",
  click_to_search: "CLICK TO SEARCH...",
  search_for: "SEARCH FOR CONTENT, FILMS AND ACTORS",
  no_results: "NO RESULTS AVAILABLE",
  more: "LOAD MORE",
  search_results_for: "RESULTS FOR",
  search_total: "TOTAL",

  // Menu strings
  tv: "TV",
};

// Испанский язык
export const ES_TRANSLATIONS: Translations = {
  // Common strings
  appname: "SCREENIFY",

  // User informing strings
  error_server: "Error del servidor. Por favor intente más tarde...",
  info_loading_wait: "Cargando. Espere por favor...",
  coming_soon: "Próximamente...",
  check_internet_headline: "Se detectó una red lenta.",
  check_internet: "Verifique su conexión por favor.",
  need_to_sign_in: "REGÍSTRESE PARA CONTINUAR VIENDO",

  // Pages strings
  home: "INICIO",
  serials: "SERIE",
  movies: "PELÍCULAS",
  collections: "COLECCIONES",
  charts: "GRÁFICOS",

  // Home page strings
  studios: "ESTUDIOS",

  // Movie page strings
  you_may_also_like: "TAMBIÉN TE PUEDE GUSTAR",
  information: "INFORMACIÓN",
  year: "AÑO",
  imdb_rating: "CALIFICACIÓN IMDB",
  country: "PAÍS",
  director: "DIRECTOR",
  no_info: "Sin información",

  // Serial page strings
  season: "TEMPORADA",
  episodes: "EPISODIOS",
  choose_season: "ELEGIR TEMPORADA",
  seasons: "TEMPORADAS",
  search: "BUSCAR",

  // Fiction page strings
  audio_tracks: "PISTAS DE AUDIO",
  subtitles: "SUBTÍTULOS",
  description: "DESCRIPCIÓN",
  watch_now: "VER AHORA",

  // Account page strings
  screenify_user: "USUARIO SCREENIFY",
  account: "CUENTA",
  sign_in: "INICIAR SESIÓN",
  email: "CORREO ELECTRÓNICO",
  email_headline: "Ingrese su correo electrónico",
  password: "CONTRASEÑA",
  password_headline: "Ingrese su contraseña",

  // Search page strings
  all_in_one: "TODO EN UNO",
  total_films_and_series: "No encuentras una película o serie? Ingresa el título de una película o serie en inglés. ¡Tenemos todo lo que necesitas!",
  click_to_search: "HAGA CLIC PARA BUSCAR...",
  search_for: "BUSCAR CONTENIDO, PELÍCULAS Y ACTORES",
  no_results: "NO HAY RESULTADOS DISPONIBLES",
  more: "CARGAR MÁS",
  search_results_for: "RESULTADOS PARA",
  search_total: "TOTAL",

  // Menu strings
  tv: "TV",
}; 